module.exports = __webpack_public_path__ + "static/img/a45a6485-7bf8-40b6-b915-a88c37ddb81e.e005e51d.png";